import { render, staticRenderFns } from "./userPrority.vue?vue&type=template&id=7b3f0439&"
import script from "./userPrority.vue?vue&type=script&lang=js&"
export * from "./userPrority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports